export const homepage_style = {
  tabStyleSx: {
    backgroundColor: 'transparent',
    width: ' 100%',
    margin: '0px auto',
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '2px solid #EBFAF7',
    '& .MuiTabs-root': {
      minHeight: 0,
    },
  },
  todaybuttonSx: {
    borderColor: 'grey.400',
    width: '82px',
    height: '32px',
  },
  headerSx: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#101010',
    textTransform: 'capitalize',
    // paddingTop: '80px',
  },

  bannerRootSx: {
    pl: 2,
    pr: 2.5,
    boxSizing: 'border-box',
    pt: '70px',
    pb: 2,
    backgroundColor: '#fff',
    position: 'fixed',
    top: 0,
    zIndex: '10',
    left: 0,
    right: 0,
    width: '100%',
    maxWidth: {
      sm: 425,
    },
    mx: {
      sm: 'auto',
    },
  },
  filterBoxSx: {
    height: 40,
    width: 40,
    borderRadius: 1,
    border: '1px solid #E3E3E3',
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  underTabStyleSx: {
    '& .MuiTabs-indicator': {
      backgroundColor: 'primary.main',
      textAlign: 'left',
    },
    '& .MuiTabs-flexContainer': {
      display: 'grid',
      gridTemplateColumns: '128px 107px 38px',
      boxSizing: 'border-box',
      width: 425,
      mx: 0.5,
      gridColumnGap: '30px',
      textAlign: 'left',
    },
  },

  numberCountSx: {
    width: '24px',
    height: '24px',
    fontSize: '14px',
  },
  tabSx: {
    textTransform: 'capitalize',
    // minHeight: 0,

    textAlign: 'left',
    color: '#000',
    whiteSpace: 'nowrap',
    fontWeight: 500,
    '&.Mui-selected': {
      textAlign: 'left',
      fontSize: '14px',
      fontWeight: 600,
    },
  },
  searchFiledSx: {
    '& .MuiOutlinedInput-root': {
      py: 0.3,
      color: '#C5C5C5',
      borderRadius: '8px',
      borderColor: '#DBEAE8',
      '&.Mui-focused fieldset': {
        borderColor: '#DBEAE8',
        color: '#0E1824',
        borderRadius: '8px',
      },
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '14px',
      color: '#0E1824',
    },
  },
  subHeadSx: {
    fontSize: '16px',
    color: '#888888',
    // p: 5.5,
    fontWeight: '25px',
    textAlign: 'center',
  },
};
